'use strict';

module.exports = {
  WIX_CODE_INTENT: 'WIX_CODE',
  CONSOLE_MESSAGE: 'console',
  SET_TO_STORAGE: 'setToStorage',
  STORAGE_UPDATE: 'storageWasUpdated'
};



// WEBPACK FOOTER //
// ./src/main/wixCodeMessageTypes.js